<template>
<div class="jumbotron" :class="{ 'has-bg-img': backgroundImage }" :style="{ backgroundImage: `url(${ backgroundImage })`}">
  <div class="container">
    <div class="row">
      <div class="col col-md-6">
        <h1>{{ title }}</h1>
        <p v-if="subtitle">{{ subtitle }}</p>
        <slot name="primary" />
      </div>
      <div class="col col-md-6 text-right">
        <slot name="secondary" />
      </div>
    </div>
    <div>
      <slot name="action" />
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'page-header',

  props: {
    title: {
      type: String,
      default: 'Title',
    },

    subtitle: {
      type: String,
      default: '',
    },

    backgroundImage: {
      type: String,
      default: '',
    },

  },

  data() {
    return {
      searchInput: ""
    }
  }
}
</script>

<style scoped>
.has-bg-img {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  color: #ffffff;
}

.has-bg-img::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.24);
}
</style>
